<template>
	<section>

    <el-card v-for="x in this.content" v-bind:key="x.id" class="box-card-component" :style="bodystyle(x.hotnews)">
      <div xslot='header' class="box-card-header">
        <h1><span v-if="x.hotnews" style='color:red'>HOT NEWS: </span>
            <span v-html="x.newstitle"></span><br/>
            <center>
            <el-button v-if="x.id==0" type='primary' size="small" xicon="el-icon-edit" @click="OpenMoreNews()">Other News</el-button>
            </center>
        </h1>        
      </div>
      <div v-if="x.id > 0">
        <img v-if="x.newsimage != ''" :src="x.newsimage" style='float:right;width:250px;margin-bottom:20px'>
        <p v-html="x.newstext"></p>
        <span style='break:both;font-size:10px;float:right;margin-bottom:5px;clear:both'>Created: {{x.newscreated}} By: {{x.newsby}}</span>
      </div>
    </el-card>
    <div style='margin-top:20px;margin-left:20px'>
    This site is intended for internal use only.<br><br>
    For more information, bugs or additional support, please contact <a href='mailto:ruud.noordermeer@tui.nl'>ruud.noordermeer@tui.nl</a> or
    <a href='mailto:Joeri.Bossuyt@tui.be'>Joeri.Bossuyt@tui.be</a>.<br><br>
    Thanks for your time!<br><br>
    Last Modified: 2022-11-16<br>
    By team: TUI Western Region Delivery (WRD)
    </div>
    <!--
    <div style='margin-left:5%'>
        <el-button type='success' round style='width:252px;margin:5px' xsize="small" @click="openLink('Music Player')">MP3 Music Player</el-button><br/>
        <el-button type='primary' round style='width:252px;margin:5px' xsize="small" @click="openLink('Search')">Search Music</el-button><br/>
        <el-button type='primary' round style='width:120px;margin:5px' xsize="small" @click="openLink('Artists')">Artist</el-button>
        <el-button type='primary' round style='width:120px;margin:5px' xsize="small" @click="openLink('Albums')">Album</el-button><br/>
        <el-button type='primary' round style='width:252px;margin:5px' xsize="small" @click="openLink('Playlists')">Playlists</el-button><br/>
      

       <div  style='margin:20px' v-if="'345689'.indexOf(userLevel) > 0">
        <div style='float:left'>
        <el-button type='primary' style='width:170px' size="small" xicon="el-icon-edit" @click="openLink('Maintain Jobs & Tasks')">Jobs and Assets</el-button>
        &nbsp;&nbsp;</div>
        <div>Maintain employees and specify assets to issue.</div>
      </div>
      <div  style='margin:20px' v-if="'345689'.indexOf(userLevel) > 0">
        <div style='float:left'>
        <el-button type='primary' style='width:170px' size="small" xicon="el-icon-edit" @click="openLink('Employees')">Employees and Assets</el-button>
        &nbsp;&nbsp;</div>
        <div>Maintain employees and specify assets to issue.</div>
      </div>
      <div style='margin:20px'>
        <div style='float:left' v-if="'345689'.indexOf(userLevel) > 0">
        <el-button type='primary' style='width:170px' size="small" xicon="el-icon-edit" @click="openLink('Employee Asset Intake')">Asset Intake</el-button> &nbsp;&nbsp;</div> <div>View open isssued items and mark as 'returned'.</div>
      </div>
      <div style='margin:20px'>
        <div style='float:left' v-if="'34589'.indexOf(userLevel) > 0">
        <el-button type='primary' style='width:170px' size="small" xicon="el-icon-edit" @click="openLink('Maintain Assets')">Maintain Asset Groups</el-button> &nbsp;&nbsp;</div> <div>Maintain assets and specifications.</div>
      </div>
    </div>
    -->
	</section>
</template>

<script>
  import settings from '../common/AppSettings';
 	import util     from '../common/AppUtil';
  import text     from '../common/AppText';
  import api      from '../api/system/xshownews';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"*"),
        util        : util,
        stack       : {},
	    	lang        : text.data,
        pageSize    : settings.pageSize,
    		serverPaging: false,

				APICode     : "XNews",
        content: [],
				counter: {},
				currentPage: 1,
				mainTotal: 0,
        userLevel: window.sessionStorage.getItem('userLevel'),
		
				listLoading: false,
			}
		},
		
		methods: {
 		  bodystyle: function(hot) {
        if (hot)  return "background-color:#eaf3ff";
        else return "";
      },

      OpenMoreNews: function() {
         var arg = {};
         this.$router.push({name: 'Latest News',arg});
      },
      
      openLink:function(link) {
         var arg = {};
         this.$router.push({name: link, arg});
      },

      // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {
				let parg = {};

				this.listLoading = true;
				
				api.getHotNews(parg).then((res) => {			
          util.processMainResults(res);
          this.codes = util.codes;          
          this.mainTotal = util.getMainPayload(this.APICode).length;

          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				});

			},
		},

		mounted() {
			this.related = settings.getRelated();
			this.getRecords();
		}
	}

</script>

<style>
  div.el-card__header {
    padding:0px 20px !important;
  }
  
  .el-dialog {
    min-width:450px;
  }
  
	.dropzone {width:200px;}

	.el-dialog__headerbtn,
	.el-message-box__headerbtn {
    border:0 !important; background:white; 
		top: 14px;
    font-size: 26px;
	}
  
	.el-form-item__error {
	  background-color:#F88C00;
  	color:white;
	  font-weight:bold;
  	z-index:3;
	  padding:3px 8px;
  	border-radius:4px;
	}
  .el-table__body-wrapper{ overflow:hidden}  /* voorkomt scrollbar in rec-tables! */

	/* RN: main color mods */

  .container .header {                     /* TOP header */
	  background-color: #4d5d69 !important; 
	}
  
	.el-menu, .el-submenu__title {          /* Linker menu: Achtergrond */
	  background: #C5CED5; 
	}

  .el-submenu__title, .topitem {           /* Linker menu: text positionering */
   padding-left: 10px !important;
  }

  .el-submenu .el-menu-item, 
  .el-submenu .el-menu-item:focus, 
  .el-submenu .el-menu-item.is-active  { /* Linker menu: Kleur submenu items */
    background-color: #B6BFC6 !important; 
    }


  .el-menu-item.is-active, .el-menu-item:focus {   /* Linker menu: Actief en 'focus' */
    background-color: #C5CED5 !important;
    color: #000; x:#70CBF4;
  }

  .el-submenu__title {                    /* Linker menu: menu items */
    line-height: 40px !important; 
    font-weight:bold !important; 
    height: 40px !important; 
    background-color: #A6B0B8!important  
  }

  .el-submenu__title:hover,  .el-menu-item:hover {  /* Linker menu: hover */
	   background-color: #5a6b78 !important; 
		 color:white !Important;
  }

  .el-submenu__title i {      /* Linker menu: kleur iconen */
  color:black;
  }

  .el-form-item {margin-bottom:10px}
  .el-dialog__body, .el-dialog__footer, .el-dialog__header {padding: 10px 15px}

  .el-notification{ width: 400px !important}
  .mediaviewer {width:100%;height:675px;overflow:hidden;overflow-y:auto;} 

  .box-card-component {margin:30px 20px;}


  .el-button--success-outline { color: #67C23A; background-color: #FFF;    border-color: #67C23A; }
  .el-button--warning-outline { color: #E6A23C; background-color: #FFF;    border-color: #E6A23C; }
  .el-button--danger-outline  { color: #F56C6C; background-color: #FFF;    border-color: #F56C6C; }
  .el-button--info-outline    { color: #909399; background-color: #FFF;    border-color: #909399; }
  .el-button--primary-outline { color: #409EFF; background-color: #FFF;    border-color: #409EFF; }

  .el-button--accent1         { color: #FFF;    background-color: #D4AC0D; border-color: #D4AC0D }  
  .el-button--accent1-outline { color: #D4AC0D; background-color: #FFF;    border-color: #D4AC0D }  
  .el-button--accent1:hover   { color: #FFF;    background-color: #B7950B; border-color: #B7950B }

  .el-button--accent2         { color: #FFF;    background-color: #AF7AC5; border-color: #AF7AC5 }
  .el-button--accent2-outline { color: #AF7AC5; background-color: #FFF;    border-color: #AF7AC5 }
  .el-button--accent2:hover   { color: #FFF;    background-color: #884EA0; border-color: #884EA0 }
  
  .el-button--accent3         { color: #FFF;    background-color: #48C9B0; border-color: #48C9B0 }
  .el-button--accent3-outline { color: #48C9B0; background-color: #FFF;    border-color: #48C9B0 }
  .el-button--accent3:hover   { color: #FFF;    background-color: #16A085; border-color: #16A085 }
  
  /*
  .el-input--nano{font-size:10px}
  .el-input--nano .el-input__inner{height:22px;line-height:22px}
  .el-input--nano .el-input__icon{line-height:22px}

  .el-button--nano {font-size:11px;border-radius:3px}
  .el-button--nano,.el-button--nano.is-round{padding:4px 10px}
  */
  .c_ended,   .danger  {color:#F56C6C;font-weight:bold}
  .c_provide, .c_deliver, .warning {color:orange;font-weight:bold}
  .c_return {color:#409EFF;font-weight:bold}  
  .c_normal {color:black;font-style:italic}
  .success {color:#67C23A}
  .info    {color:#909399}
  .primary {color:#409EFF}

  .cmdIcon {font-weight:bold;font-size:12px}


</style>


// WEBPACK FOOTER //
// Main.vue?f233a996